/**
 * Carousel arrow navigation.
 * Scrolls the [data-carousel] container by one "page" worth of visible width.
 * Disables arrows at scroll boundaries — unless [data-carousel-loop] is set,
 * in which case clicks at the boundary wrap to the opposite end.
 *
 * Opt-in attributes (on [data-carousel]):
 *   data-carousel-loop                 → arrows cycle instead of disabling
 *   data-carousel-autoplay="5000"      → auto-advance every N ms; pauses on
 *                                        hover/focus/touch and when tab hidden;
 *                                        disabled under prefers-reduced-motion
 */
(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function scrollBehavior() { return reducedMotion.matches ? 'auto' : 'smooth'; }

  document.querySelectorAll('[data-carousel]').forEach(function (track) {
    var wrap = track.closest('.carousel-wrap');
    if (!wrap) return;

    var prevBtn = wrap.querySelector('[data-carousel-prev]');
    var nextBtn = wrap.querySelector('[data-carousel-next]');
    if (!prevBtn || !nextBtn) return;

    var loop = track.hasAttribute('data-carousel-loop');
    var autoplayMs = parseInt(track.getAttribute('data-carousel-autoplay'), 10) || 0;

    function maxScroll() { return track.scrollWidth - track.clientWidth; }

    function updateArrows() {
      if (loop) {
        prevBtn.disabled = false;
        nextBtn.disabled = false;
        return;
      }
      var scrollLeft = Math.round(track.scrollLeft);
      prevBtn.disabled = scrollLeft <= 1;
      nextBtn.disabled = scrollLeft >= maxScroll() - 1;
    }

    function goNext() {
      var max = maxScroll();
      if (loop && Math.round(track.scrollLeft) >= max - 1) {
        track.scrollTo({ left: 0, behavior: scrollBehavior() });
      } else {
        track.scrollBy({ left: track.clientWidth * 0.8, behavior: scrollBehavior() });
      }
    }

    function goPrev() {
      if (loop && Math.round(track.scrollLeft) <= 1) {
        track.scrollTo({ left: maxScroll(), behavior: scrollBehavior() });
      } else {
        track.scrollBy({ left: -track.clientWidth * 0.8, behavior: scrollBehavior() });
      }
    }

    prevBtn.addEventListener('click', goPrev);
    nextBtn.addEventListener('click', goNext);

    track.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
    window.addEventListener('load', updateArrows);

    // ── Autoplay ──
    if (autoplayMs > 0 && !reducedMotion.matches) {
      var timer = null;
      function start() {
        if (timer) return;
        timer = window.setInterval(goNext, autoplayMs);
      }
      function stop() {
        if (!timer) return;
        window.clearInterval(timer);
        timer = null;
      }
      start();
      wrap.addEventListener('pointerenter', stop);
      wrap.addEventListener('pointerleave', start);
      wrap.addEventListener('focusin', stop);
      wrap.addEventListener('focusout', start);
      wrap.addEventListener('touchstart', stop, { passive: true });
      wrap.addEventListener('touchend', start, { passive: true });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });
    }
  });
})();
